import styled from 'styled-components/macro';

export const SocialLoginContainer = styled.div`
  display: flex;
  gap: 3.2rem;
  margin-top: 3.2rem;
`;
